export default __webpack_public_path__ + "static/media/kitchen5-afterA-2048w.882b47c5.webp";